import Constants from '@/Constants';
import { OrganizationStatsRequest } from '@/models/OrganizationStatsRequests';
import { PasswordRules } from '@/models/PasswordRules';
import http from '@/services/HttpService';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { call, put, select } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { ApplicationState } from '../index';
import {
    getAppOrgFailure,
    getAppOrgSuccess,
    getOrganizationStatsFailure,
    getOrganizationStatsSuccess,
    getPasswordRulesFailure,
    getPasswordRulesSuccess,
    setConfigFailure,
    setConfigSuccess
} from './action';
import { AppOrganization, AppOrganizationTypes, SetConfigRequestData } from './types';

export function* getAppOrg(action: PayloadAction<AppOrganizationTypes.GET_APP_ORGANIZATION_REQUEST, string>) {
    try {
        const { data } = yield call(http.get, `${Constants.APP_ORG_URI}/${action.payload}`);
        yield put(getAppOrgSuccess(data));
    } catch (error) {
        yield put(getAppOrgFailure());
    }
}

export function* setConfig(action: PayloadAction<AppOrganizationTypes.SET_CONFIG_REQUEST, SetConfigRequestData>) {
    const { appOrganization, strings, orgId } = yield select((state: ApplicationState) => ({
        appOrganization: state.appOrganization.data,
        strings: state.locale.data,
        orgId: state.identity.data.person.orgId,
    }));

    try {
        const { color, logo, banner, bannerActivated, hasBanner } = action.payload;
        const newAppOrganization = {
            ...appOrganization,
            colors: [color, color, color, color],
            customLogoFileName: logo,

            dynamicAttributes: {
                ...appOrganization.dynamicAttributes,
                customBannerFileName: banner,
                bannerActivated,
                hasBanner,
            },
        } as AppOrganization;

        yield call(http.put, `${Constants.APP_ORG_URI}/applications/11/organizations/${orgId}/theme`, newAppOrganization);
        toast.success(strings.toastMessages.CONFIGURATION_SUCCESS);
        yield put(setConfigSuccess());
        window.location.reload();
    } catch (error) {
        toast.error(strings.toastMessages.CONFIGURATION_ERROR);
        yield put(setConfigFailure(error as AxiosError));
    }
}

export function* getPasswordRulesRequest(action: PayloadAction<AppOrganizationTypes.GET_PASSWORD_RULES_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, Constants.PASSWORD_RULES_URI.replace('%o', action.payload.toString()));
        yield put(getPasswordRulesSuccess(transformObjectToCamelCase(data)));
    } catch (error) {
        yield put(getPasswordRulesFailure());
    }
}

const transformObjectToCamelCase = function(o: object) {
    const toCamel = (attribute: string) => {
        return attribute.replace(/([-_][a-z])/gi, (attr) => {
            return attr
                .toUpperCase()
                .replace('-', '')
                .replace('_', '');
        });
    };
    const n: PasswordRules = {} as PasswordRules;
    Object.keys(o).forEach((k: string) => {
        const attr = toCamel(k) as string;
        const attrVal = o[k as never];
        n[attr] = attrVal;
    });
    return n;
};

export function* getOrganizationStatsRequest(action: PayloadAction<AppOrganizationTypes.GET_ORGANIZATION_STATS_REQUEST, OrganizationStatsRequest>) {
    try {
        const { organizationId, applicationId, moduleIds } = action.payload;
        const path = Constants.GET_ORGANIZATION_STATS_URI.replace('%orgId', organizationId.toString()).replace('%appId', applicationId.toString());
        const queryParams = `?moduleIds=${moduleIds}`;
        const { data } = yield call(http.get, `${path}${queryParams}`);
        yield put(getOrganizationStatsSuccess(data));
    } catch (error) {
        yield put(getOrganizationStatsFailure(error as AxiosError));
    }
}
